import { render, staticRenderFns } from "./RecentSignups.vue?vue&type=template&id=2c646f80&scoped=true"
import script from "./RecentSignups.vue?vue&type=script&lang=js"
export * from "./RecentSignups.vue?vue&type=script&lang=js"
import style0 from "./RecentSignups.vue?vue&type=style&index=0&id=2c646f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c646f80",
  null
  
)

export default component.exports